import { NgModule } from "@angular/core";
import { AuthModule, LogLevel } from "angular-auth-oidc-client";
import { environment } from "src/environments/environment";

@NgModule({
    imports: [
        AuthModule.forRoot({
            config: {
              configId: 'dms-website',
              authority: 'https://auth.langworthytech.com/realms/dms-app',
              redirectUrl: window.location.origin,
              postLogoutRedirectUri: window.location.origin,
              clientId: 'dms-website',
              scope: 'openid profile offline_access',
              responseType: 'code',
              silentRenew: true,
              useRefreshToken: true,
              ignoreNonceAfterRefresh: true,
              triggerRefreshWhenIdTokenExpired: true,
              logLevel: LogLevel.Debug,
              secureRoutes: [environment.apiUrl]
            }
          }),
    ],
    exports: [AuthModule],
    declarations: [
    ]
})
export class AuthConfigModule {}